import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import { clearLocalStorageItems } from "../../utils/authUtils";

const useHandleUnauthorized = () => {
  const { logout } = useAuth0();

  const handleUnauthorized = useCallback((error) => {
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access detected - token may have expired");
      clearLocalStorageItems();
      logout({ logoutParams: { returnTo: window.location.origin } });
      // Force page reload to clear state
      window.location.reload();
    }
  }, [logout]);

  return handleUnauthorized;
};

export default useHandleUnauthorized;
